<ion-header class="ion-no-border">

	<ion-toolbar>
		<ion-buttons slot="start">
			<ion-button (click)="close()">
				<fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
			</ion-button>
		</ion-buttons>
		<ion-title>
			Add payment
			<p *ngIf="order" class="subtitle">Order #{{order.number}}</p>
		</ion-title>
		<ion-buttons *ngIf="online && !loading" slot="end">
			<ion-button (click)="add()">
				<fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
			</ion-button>
		</ion-buttons>
	</ion-toolbar>

</ion-header>

<ion-content>

    <ion-grid *ngIf="online && !loading && order" class="form">
        <ion-row>
            <ion-col>
                <ion-grid class="fieldset">
                    <ion-row>
                        <ion-col>
                            <ion-select cancelText="Close" interface="alert" label="Method" labelPlacement="stacked" fill="outline" (ionChange)="methodChanged()" [(ngModel)]="params.method">
                                <ion-select-option *ngIf="stripe_terminal_connected || smartpay_connected" value="credit_card">Card</ion-select-option>
                                <ion-select-option value="bank_transfer">Bank transfer</ion-select-option>
                                <ion-select-option value="cash">Cash</ion-select-option>
                                <ion-select-option *ngIf="!stripe_terminal_connected && !smartpay_connected" value="external_card">External card</ion-select-option>
                                <ion-select-option value="gift_voucher">Gift voucher</ion-select-option>
                                <ion-select-option value="cheque">Cheque</ion-select-option>
                                <ion-select-option *ngIf="person_store_credit && person_store_credit.balance != 0" value="person_store_credit">Person store credit</ion-select-option>
                                <ion-select-option *ngIf="organisation_store_credit && organisation_store_credit.balance != 0" value="organisation_store_credit">Organisation store credit</ion-select-option>
                                <ion-select-option *ngIf="custom_payment_services && custom_payment_services.length > 0" value="custom">Custom</ion-select-option>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                    <ion-row *ngIf="params.method == 'gift_voucher' && gift_vouchers">
                        <ion-col>
                            <ion-select cancelText="Close" interface="alert" label="Gift voucher" labelPlacement="stacked" fill="outline" [(ngModel)]="gift_voucher_id">
                                <ion-select-option *ngFor="let gift_voucher of gift_vouchers" value="{{gift_voucher.id}}">{{gift_voucher.code}} ({{gift_voucher.currency.sign}}{{gift_voucher.remaining_balance | number:'1.2'}} available)</ion-select-option>
                                <ion-select-option value="">Other</ion-select-option>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                    <ion-row *ngIf="params.method == 'gift_voucher' && (!gift_vouchers || gift_voucher_id == '')">
                        <ion-col>
                            <ion-input type="text" inputmode="text" maxlength="20" label="Gift voucher code" labelPlacement="stacked" fill="outline" [(ngModel)]="gift_voucher_code"></ion-input>
                        </ion-col>
                    </ion-row>
                    <ion-row *ngIf="params.method == 'custom'">
                        <ion-col>
                            <ion-select cancelText="Close" interface="alert" label="Payment service" labelPlacement="stacked" fill="outline" [(ngModel)]="params.payment_service_id">
                                <ng-container *ngFor="let custom_payment_service of custom_payment_services">
                                    <ion-select-option *ngIf="custom_payment_service.status == 'active'" value="{{custom_payment_service.id}}">{{custom_payment_service.name}}</ion-select-option>
                                </ng-container>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                    <ion-row *ngIf="params.method == 'custom'">
                        <ion-col>
                            <ion-input type="text" inputmode="text" maxlength="50" labelPlacement="stacked" fill="outline" [(ngModel)]="params.payment_service_transaction_id">
                                <div slot="label">Payment service transaction ID<ion-text class="optional">optional</ion-text></div>
                            </ion-input>
                        </ion-col>
                    </ion-row>
                    <ion-row *ngIf="params.method == 'person_store_credit' && person_store_credit">
                        <ion-col>
                            <h5>Store credit balance</h5>
                            <p class="prominent">{{order.currency.sign}}{{person_store_credit.balance | number:'1.2'}}</p>
                        </ion-col>
                    </ion-row>
                    <ion-row *ngIf="params.method == 'organisation_store_credit' && organisation_store_credit">
                        <ion-col>
                            <h5>Store credit balance</h5>
                            <p class="prominent">{{order.currency.sign}}{{organisation_store_credit.balance | number:'1.2'}}</p>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-input debounce="50" inputmode="decimal" maxlength="10" label="Amount" labelPlacement="stacked" fill="outline" (ngModelChange)="recalculateSurcharge($event)" [(ngModel)]="price_without_surcharge"></ion-input>
                        </ion-col>
                    </ion-row>
                    <ion-row *ngIf="surchargable_method && surcharge_rate && surcharge_rate > 0">
                        <ion-col>
                            <ion-toggle class="form-toogle" alignment="start" label-placement="stacked" (ionChange)="recalculateSurcharge(price_without_surcharge)" [(ngModel)]="surcharge_enabled">Apply {{surcharge_rate}}% surcharge</ion-toggle>
                        </ion-col>
                    </ion-row>
                    <ion-row *ngIf="surchargable_method && surcharge_rate && surcharge_rate > 0 && surcharge_enabled">
                        <ion-col>
                            <h5>Amount with surcharge</h5>
                            <p class="prominent">{{order.currency.sign}}{{params.price | number:'1.2'}}</p>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-input *ngIf="params['date']" class="modal-input" readonly="true" label="Date" labelPlacement="stacked" fill="outline" value={{formatted_date}} (click)="presentDateTimePickerModal()"></ion-input>
                            <ion-input *ngIf="!params['date']" class="modal-input" readonly="true" label="Date" labelPlacement="stacked" fill="outline" (click)="presentDateTimePickerModal()"></ion-input>
                        </ion-col>
                    </ion-row>
                    <ion-row *ngIf="order.person && order.person.email_address">
                        <ion-col>
                            <ion-item lines="none" class="ion-no-padding">
                                <ion-toggle class="form-toogle" alignment="start" label-placement="stacked" [(ngModel)]="params.send_order_payment_receipt_email">Send payment receipt email</ion-toggle>
                            </ion-item>
                        </ion-col>
                    </ion-row>
                    <ion-row *ngIf="xero_connected && order.xero_invoice_id">
                        <ion-col>
                            <ion-item lines="none" class="ion-no-padding">
                                <ion-toggle class="form-toogle" alignment="start" label-placement="stacked" [(ngModel)]="params.add_xero_invoice_payment">Add payment to Xero invoice</ion-toggle>
                            </ion-item>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-col>
        </ion-row>
    </ion-grid>

</ion-content>
